import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeCancel", "children", "onClick", "tourKey"];
import { memo, useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { deactivateTour } from '../lib/deactivateTour';
import { jsx as _jsx } from "react/jsx-runtime";
const UITourCancelButton = /*#__PURE__*/memo(_ref => {
  let {
      beforeCancel = emptyFunction,
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "shepherd-react.cancel"
      }),
      onClick,
      tourKey
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tour
  } = useContext(TourContext);
  const {
    getTour,
    getStep
  } = tour;
  const handleClick = () => {
    handleCallback(beforeCancel, () => {
      if (typeof onClick === 'function') {
        onClick();
      }
      deactivateTour(tour, tourKey);
    }, {
      tourKey: tourKey || getTour(),
      stepKey: getStep()
    });
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: "secondary"
  }, buttonProps, {
    onClick: handleClick,
    children: children
  }));
});
export default UITourCancelButton;